import axios from 'axios';
import { API_URL } from '../constants/index.js';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

const wrap = (resource, method, url, data) => axios({ method, url: `${API_URL}${url}`, data, params: method === 'get' ? data : undefined });

export const cmsEditorialStatuses = [
	{ value: 'draft', label: 'Draft' },
	{ value: 'review', label: 'In review' },
	{ value: 'published', label: 'Published' },
	{ value: 'archived', label: 'Archived' },
];

export function getDestinationsAdmin(params = {}) {
	return wrap('destinations', 'get', '/destinations', { admin_list: 'true', per_page: 20, ...params });
}

export function getDestinationAdmin(slug) {
	return wrap('destinations', 'get', `/destinations/${slug}`);
}

export function createDestination(data) {
	return wrap('destinations', 'post', '/destinations', { destination: data });
}

export function updateDestination(slug, data) {
	return wrap('destinations', 'put', `/destinations/${slug}`, { destination: data });
}

export function deleteDestination(slug) {
	return wrap('destinations', 'delete', `/destinations/${slug}`);
}

export function getFestivalsAdmin(params = {}) {
	return wrap('festivals', 'get', '/festivals', { admin_list: 'true', per_page: 20, ...params });
}

export function getFestivalAdmin(slug) {
	return wrap('festivals', 'get', `/festivals/${slug}`);
}

export function createFestival(data) {
	return wrap('festivals', 'post', '/festivals', { festival: data });
}

export function updateFestival(slug, data) {
	return wrap('festivals', 'put', `/festivals/${slug}`, { festival: data });
}

export function deleteFestival(slug) {
	return wrap('festivals', 'delete', `/festivals/${slug}`);
}

export function getGuidesAdmin(params = {}) {
	return wrap('guides', 'get', '/guides', { admin_list: 'true', per_page: 20, ...params });
}

export function getGuideAdmin(slug) {
	return wrap('guides', 'get', `/guides/${slug}`);
}

export function createGuide(data) {
	return wrap('guides', 'post', '/guides', { guide: data });
}

export function updateGuide(slug, data) {
	return wrap('guides', 'put', `/guides/${slug}`, { guide: data });
}

export function deleteGuide(slug) {
	return wrap('guides', 'delete', `/guides/${slug}`);
}

/** AI draft — requires OPENAI_API_KEY on backend. Saves nothing; returns draft fields. */
export function generateContentDraft({ kind, title, category, context }) {
	return wrap('content_generations', 'post', '/admin/content_generations', {
		kind,
		title,
		category,
		context,
	});
}

export function getJourneysAdmin(params = {}) {
	return wrap('journeys', 'get', '/journeys', { admin_list: 'true', per_page: 20, ...params });
}

export function getJourneyAdmin(slug) {
	return wrap('journeys', 'get', `/journeys/${slug}`);
}

export function createJourney(data) {
	return wrap('journeys', 'post', '/journeys', { journey: data });
}

export function updateJourney(slug, data) {
	return wrap('journeys', 'put', `/journeys/${slug}`, { journey: data });
}

export function deleteJourney(slug) {
	return wrap('journeys', 'delete', `/journeys/${slug}`);
}

export function duplicateJourney(slug) {
	return wrap('journeys', 'post', `/journeys/${slug}/duplicate`);
}

export function bulkUpdateJourneyAvailability(slugs, availableMonths) {
	return wrap('journeys', 'put', '/journeys/bulk_availability', {
		slugs,
		available_months: availableMonths,
	});
}

export function getContentMediaAdmin(params = {}) {
	return wrap('content_media', 'get', '/content_media', { admin_list: 'true', per_page: 24, ...params });
}

export function getContentMediumAdmin(id) {
	return wrap('content_media', 'get', `/content_media/${id}`);
}

export function createContentMedium(data) {
	return wrap('content_media', 'post', '/content_media', { content_medium: data });
}

export function updateContentMedium(id, data) {
	return wrap('content_media', 'put', `/content_media/${id}`, { content_medium: data });
}

export function deleteContentMedium(id) {
	return wrap('content_media', 'delete', `/content_media/${id}`);
}

export function getOfficialSourcesAdmin(params = {}) {
	return wrap('official_sources', 'get', '/official_sources', { admin_list: 'true', per_page: 20, ...params });
}

export function getOfficialSourceAdmin(slug) {
	return wrap('official_sources', 'get', `/official_sources/${slug}`);
}

export function createOfficialSource(data) {
	return wrap('official_sources', 'post', '/official_sources', { official_source: data });
}

export function updateOfficialSource(slug, data) {
	return wrap('official_sources', 'put', `/official_sources/${slug}`, { official_source: data });
}

export function deleteOfficialSource(slug) {
	return wrap('official_sources', 'delete', `/official_sources/${slug}`);
}
